import { ApolloClient, ApolloLink } from '@apollo/client'
import { cache } from '@mercadoni/sinister/dist/cjs/shared/services'
import { VERSION } from '../config'

const generateApolloClient = ({
  ssrMode,
  directionalLink,
}: {
  ssrMode: boolean
  directionalLink: ApolloLink
}) => {
  return new ApolloClient({
    ssrMode,
    link: directionalLink,
    cache,
    name: 'Ecommerce SSR',
    version: VERSION,
    headers: {
      'client-name': 'ecommerce Makkari',
      'client-version': VERSION,
    },
  })
}

export default generateApolloClient
